(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cilea-oval-configurator"] && !Shopify.designMode) return;
  try {
    
(function () {
  function install(root) {
    if (root.dataset.ovalMounted === 'true') return;
    root.dataset.ovalMounted = 'true';
    const state = { item: 'necklace', structure: 'hollow', width: '2.9', length: '50', clasp: 'spring_ring' };
    let metalColor = 'yg';
    const lengths = { necklace: '50', bracelet: '18' };
    const customLengths = { necklace: '', bracelet: '' };
    let customWidth = '';
    let linkMode = 'consult';
    let customLinkLength = '';
    let selectedLinkLength = '';
    let hasCustomSelection = false;
    function selectionKey() { return JSON.stringify([state,metalColor,customWidth,customLengths,linkMode,customLinkLength,selectedLinkLength]); }
    function markCustomSelection() { hasCustomSelection = true;root.querySelector('[data-oval-reference-photo]').open = false;root.querySelector('[data-oval-preview-slot]').scrollTop = 0; }
    const linkLengthInput = root.querySelector('[data-oval-custom-link-length]');
    const linkInputGroup = root.querySelector('[data-oval-link-input-group]');
    const customWidthInput = root.querySelector('[data-oval-custom-width]');
    const customLengthInput = root.querySelector('[data-oval-custom-length]');
    const validation = root.querySelector('[data-oval-validation]');
    const copyButton = root.querySelector('[data-oval-copy]');
    const lineLink = root.querySelector('[data-oval-line]');
    function dimensionError(value, item, dimension) {
      if (!/^\d{1,4}(?:\.\d{1,2})?$/.test(value) || Number(value) <= 0) return 'ご希望のサイズは0より大きい半角数字でご入力ください（小数2桁まで）。';
      if (dimension === 'length' && item === 'necklace' && (Number(value) < 40 || Number(value) > 70)) return 'ネックレスのご希望の長さは40〜70cmでご入力ください。';
      return '';
    }
    const get = (name) => root.querySelector('[data-oval-summary-' + name + ']');
    const itemLabel = { necklace: 'ネックレス', bracelet: 'ブレスレット' };
    const claspLabel = { spring_ring: '引き輪＋プレート', toggle: 'バータイプ（マンテル）' };
    const metalLabel = {yg:'イエローゴールド',wg:'ホワイトゴールド',pg:'ピンクゴールド'};
    const metalPalette = {yg:{dark:'#6e4a13',base:'#c69c48',light:'#fff5cf',mid:'#e9c978'},wg:{dark:'#454c56',base:'#a3abb5',light:'#ffffff',mid:'#dbe1e7'},pg:{dark:'#7b4038',base:'#cc9283',light:'#fff0e8',mid:'#edbcb0'}};
    const structureLabel = { hollow: '中空（軽量仕様）', solid: '無垢' };
    const quoteText = root.querySelector('[data-oval-quote-text]');
    const copyStatus = root.querySelector('[data-oval-copy-status]');
    const photo = root.querySelector('.cilea-oval__photo img');

    const editor = root.querySelector('[data-oval-editor]');
    const visual = root.querySelector('.cilea-oval__visual');
    const controls = root.querySelector('.cilea-oval__controls');
    const catalog = root.querySelector('.cilea-oval__product-nav');
    const stepNavigation = root.querySelector('[data-oval-step-navigation]');
    const panels = Array.from(root.querySelectorAll('[data-oval-panel]'));
    const stepTitle = root.querySelector('[data-oval-step-title]');
    const stepCount = root.querySelector('[data-oval-step-count]');
    const stepBack = root.querySelector('[data-oval-back]');
    const stepNext = root.querySelector('[data-oval-next]');
    const currentSelection = root.querySelector('[data-oval-current]');
    const stepNames = ['アイテム','チェーンの構造','ジュエリーカラー','チェーンの幅','コマ1個の長さ','チェーン全体の長さ','留め具','選択内容の確認'];
    let currentStep = 0;
    const canStage = editor && panels.length === 8;
    if (canStage) {
      root.querySelector('[data-oval-preview-slot]').append(visual);
      root.querySelector('[data-oval-controls-slot]').append(controls);
      root.querySelector('[data-oval-inline-meta]').after(catalog);
      root.querySelector('.cilea-oval__layout').hidden = true;
      root.querySelector('[data-oval-inline-meta]').hidden = false;
      editor.hidden = false;
      stepNavigation.hidden = false;
    }
    function stepError() {
      const width = customWidth.trim() || state.width;
      const length = customLengths[state.item].trim() || state.length;
      const linkLength = linkMode === 'consult' ? null : linkMode === 'custom' ? customLinkLength.trim() : selectedLinkLength;
      if (currentStep === 3) return dimensionError(width, state.item, 'width');
      if (currentStep === 4) return linkLength === null ? '' : dimensionError(linkLength, state.item, 'linkLength');
      if (currentStep === 5) return dimensionError(length, state.item, 'length');
      if (currentStep === 7) return dimensionError(width,state.item,'width') || dimensionError(length,state.item,'length') || (linkLength === null ? '' : dimensionError(linkLength,state.item,'linkLength'));
      return '';
    }
    function updateStep() {
      if (!canStage) return;
      panels.forEach((panel,index) => { panel.hidden = index !== currentStep; });
      stepTitle.textContent = stepNames[currentStep];
      stepCount.textContent = String(currentStep + 1).padStart(2,'0') + ' / 08';
      stepBack.disabled = currentStep === 0;
      stepNext.hidden = currentStep === 7;
      stepNext.textContent = currentStep === 6 ? '確認へ' : '次へ';
      stepNext.setAttribute('aria-label', currentStep === 6 ? '選択内容を確認する' : (stepNames[currentStep + 1] || '') + 'へ進む');
      const error = stepError();
      stepNext.disabled = Boolean(error);
      validation.textContent = error;
      validation.hidden = !error;
      const selected = [itemLabel[state.item],structureLabel[state.structure],metalColor.toUpperCase() + '（' + metalLabel[metalColor] + '）',(customWidth.trim() || state.width) + 'mm',linkMode === 'consult' ? '相談して決める' : (linkMode === 'custom' ? customLinkLength.trim() : selectedLinkLength) + 'mm',(customLengths[state.item].trim() || state.length) + 'cm',claspLabel[state.clasp],'価格・納期は個別にお見積もりいたします'];
      currentSelection.textContent = (currentStep === 7 ? '' : '選択中：') + selected[currentStep];
      root.querySelectorAll('[data-oval-progress]').forEach(item => {
        if (Number(item.dataset.ovalProgress) === currentStep) item.setAttribute('aria-current','step');
        else item.removeAttribute('aria-current');
      });
    }
    function moveStep(delta) {
      if (!canStage || (delta > 0 && stepError())) return;
      currentStep = Math.max(0,Math.min(7,currentStep + delta));
      updateStep();
      panels[currentStep].scrollTop = 0;
      root.querySelector('[data-oval-preview-slot]').scrollTop = 0;
      stepTitle.focus({preventScroll:true});
    }
    function resetSelection() {
      Object.assign(state,{item:'necklace',structure:'hollow',width:'2.9',length:'50',clasp:'spring_ring'});
      metalColor = 'yg';lengths.necklace = '50';lengths.bracelet = '18';
      customLengths.necklace = '';customLengths.bracelet = '';customWidth = '';
      linkMode = 'consult';customLinkLength = '';selectedLinkLength = '';hasCustomSelection = false;
      customWidthInput.value = '';customLengthInput.value = '';linkLengthInput.value = '';
      root.querySelector('[data-oval-reference-photo]').open = true;
      root.querySelector('.cilea-oval__preview-notes').open = false;
      currentStep = 0;sync();
      root.querySelector('[data-oval-preview-slot]').scrollTop = 0;
      stepTitle.focus({preventScroll:true});
    }
    if (canStage) {
      stepBack.addEventListener('click',() => moveStep(-1));
      stepNext.addEventListener('click',() => moveStep(1));
      root.querySelector('[data-oval-reset]').addEventListener('click',resetSelection);
    }

    function claspShape(type) {
      return type === 'toggle'
        ? '<circle cx="25" cy="0" r="18"/><circle cx="25" cy="0" r="13"/><ellipse cx="2" cy="0" rx="5" ry="4"/><g transform="translate(25 0) rotate(-45)"><rect x="-3" y="-28" width="6" height="56" rx="3"/><path d="M-1 -25V25"/></g>'
        : '<circle cx="23" cy="0" r="18"/><circle cx="23" cy="0" r="12.5"/><path d="M10 -13L14 -9M7 -9L12 -6M23 -18V-25H27V-18"/><path d="M38 -8H72A8 8 0 0 1 72 8H38A8 8 0 0 1 38 -8Z"/><circle cx="38" cy="0" r="4"/><circle cx="72" cy="0" r="4"/>';
    }
    function claspHelp(type) {
      return type === 'toggle' ? 'バーを輪に通し、横向きにして留めます。' : '小さな引き手を引いて輪を開き、プレートの穴に掛けて留めます。';
    }
    function drawCombination(width, linkLength, length, error) {
      const svg = root.querySelector('[data-oval-combination-svg]');
      const shapes = root.querySelector('[data-oval-combination-shapes]');
      const spec = root.querySelector('[data-oval-combination-spec]');
      const note = root.querySelector('[data-oval-combination-note]');
      const detail = root.querySelector('[data-oval-clasp-detail-image]');
      root.setAttribute('data-oval-metal-color', metalColor);
      detail.setAttribute('data-clasp-render', state.clasp);
      detail.setAttribute('aria-label', metalColor.toUpperCase() + ' ' + claspLabel[state.clasp] + 'の参考CG。' + claspHelp(state.clasp));
      const palette = metalPalette[metalColor];
      const ident = 'oval-metal-' + String(root.id || 'preview').replace(/[^a-zA-Z0-9_-]/g, '');
      function metalDefs(id) {
        return '<defs><linearGradient id="' + id + '" x1="0" y1="0" x2=".25" y2="1"><stop offset="0" stop-color="' + palette.dark + '"/><stop offset=".15" stop-color="' + palette.base + '"/><stop offset=".3" stop-color="' + palette.light + '"/><stop offset=".43" stop-color="' + palette.mid + '"/><stop offset=".57" stop-color="' + palette.dark + '"/><stop offset=".73" stop-color="' + palette.base + '"/><stop offset=".87" stop-color="' + palette.light + '"/><stop offset="1" stop-color="' + palette.dark + '"/></linearGradient></defs>';
      }
      function metalHardware(type,id) {
        return '<g fill="none" stroke="' + palette.dark + '" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">' + claspShape(type) + '</g><g fill="none" stroke="url(#' + id + ')" stroke-width="1.15" stroke-linecap="round" stroke-linejoin="round">' + claspShape(type) + '</g>';
      }
      root.querySelector('[data-oval-clasp-detail-name]').textContent = claspLabel[state.clasp];
      root.querySelector('[data-oval-clasp-detail-help]').textContent = claspHelp(state.clasp);
      if (error) {
        shapes.innerHTML = '';svg.setAttribute('aria-label', 'サイズをご入力いただくとイメージを表示いたします');
        spec.textContent = 'サイズをご入力いただくとイメージを表示いたします。';note.textContent = '';return;
      }
      const w = Number(width), l = linkLength === null ? 8 : Number(linkLength);
      const ratio = w / l;
      const visualRatio = Math.max(0.16, Math.min(0.72, ratio));
      const linkPixels = Math.max(52, Math.min(100, l * 10));
      const shortPixels = linkPixels * visualRatio;
      const spacing = linkPixels * 0.53;
      const startX = 85, rise = state.item === 'necklace' ? -10 : -5;
      let markup = metalDefs(ident);
      function capsulePath(length, height) {
        const x = length / 2, y = height / 2, r = Math.min(height / 2, length / 3);
        return 'M' + (-x+r) + ' ' + (-y) + 'H' + (x-r) + 'C' + (x+r*.35) + ' ' + (-y) + ' ' + (x+r*.35) + ' ' + y + ' ' + (x-r) + ' ' + y + 'H' + (-x+r) + 'C' + (-x-r*.35) + ' ' + y + ' ' + (-x-r*.35) + ' ' + (-y) + ' ' + (-x+r) + ' ' + (-y) + 'Z';
      }
      function drawLink(i) {
        const edge = i % 2 === 1;
        const x = startX + i * spacing, y = 166 + i * rise;
        const len = linkPixels * (edge ? .91 : 1), h = shortPixels * (edge ? .25 : .85);
        const path = capsulePath(len, h);
        const wire = Math.max(4, Math.min(7, shortPixels * .18));
        return '<g transform="translate(' + x + ' ' + y + ') rotate(-12)"><path d="' + path + '" transform="translate(0 2)" fill="none" stroke="#655b4e" stroke-width="' + (wire+1.8) + '" opacity=".13"/><path d="' + path + '" fill="none" stroke="' + palette.dark + '" stroke-width="' + wire + '"/><path d="' + path + '" fill="none" stroke="url(#' + ident + ')" stroke-width="' + (wire-.8) + '"/><path d="' + path + '" transform="translate(-.6 -.7)" fill="none" stroke="#fffdf5" stroke-width=".7" opacity=".7"/><path d="' + path + '" transform="translate(.8 .9)" fill="none" stroke="' + palette.dark + '" stroke-width=".55" opacity=".55"/></g>';
      }
      for (let i = 1; i < 7; i += 2) markup += drawLink(i);
      for (let i = 0; i < 7; i += 2) markup += drawLink(i);
      const halfL = linkPixels / 2, halfW = shortPixels * .85 / 2;
      markup += '<g transform="translate(' + startX + ' 166) rotate(-12)" fill="none" stroke="#b7b0a6" stroke-width=".55"><path d="M' + (-halfL) + ' ' + (-halfW-6) + 'V' + (-halfW-25) + 'M' + halfL + ' ' + (-halfW-6) + 'V' + (-halfW-25) + 'M' + (-halfL-3) + ' ' + (-halfW-20) + 'H' + (halfL+3) + 'M' + (-halfL-12) + ' ' + (-halfW) + 'H' + (-halfL-20) + 'M' + (-halfL-12) + ' ' + halfW + 'H' + (-halfL-20) + 'M' + (-halfL-16) + ' ' + (-halfW-3) + 'V' + (halfW+3) + '"/><text x="0" y="' + (-halfW-28) + '" text-anchor="middle" fill="#8e877e" stroke="none" font-family="Arial,sans-serif" font-size="8">' + l + ' mm' + (linkLength === null ? '*' : '') + '</text><text x="' + (-halfL) + '" y="' + (halfW+18) + '" text-anchor="start" fill="#8e877e" stroke="none" font-family="Arial,sans-serif" font-size="7">' + width + ' mm</text></g>';
      const endX = startX + 6 * spacing + linkPixels / 2 + 5;
      const y = 166 + 6 * rise;
      const hardware = claspShape(state.clasp);
      markup += '<g transform="translate(' + endX + ' ' + y + ') rotate(-12)">' + metalHardware(state.clasp,ident) + '</g>';
      markup += '<path d="M42 223H558" fill="none" stroke="#e5e1da" stroke-width=".6"/><text x="42" y="242" fill="#9b968e" font-family="Arial,sans-serif" font-size="8" letter-spacing="2">LINK &amp; CLASP DETAIL</text>';
      shapes.innerHTML = markup;
      spec.textContent = itemLabel[state.item] + ' ／ ' + metalColor.toUpperCase() + ' ／ ' + structureLabel[state.structure] + ' ／ 幅' + width + 'mm ／ コマ' + (linkLength === null ? '相談して決める' : linkLength + 'mm') + ' ／ 全長' + length + 'cm ／ ' + claspLabel[state.clasp];
      svg.setAttribute('aria-label', '参考イラスト：' + spec.textContent);
      const baseline = linkLength === null ? 'コマの長さは未指定のため、8mmを作図上の基準として表示しております。' : '';
      const adjusted = ratio !== visualRatio || l * 10 !== linkPixels ? '見やすさのため、図の比率・大きさを調整しております。' : '';
      note.textContent = baseline + adjusted + '全長は表示値のみの反映で、図はチェーンの一部分です。';
    }

    function sync() {
      root.querySelector('[data-oval-combination-panel]').hidden = !hasCustomSelection;
      const width = customWidth.trim() || state.width;
      const length = customLengths[state.item].trim() || state.length;
      const linkLength = linkMode === 'consult' ? null : linkMode === 'custom' ? customLinkLength.trim() : selectedLinkLength;
      const linkError = linkLength === null ? '' : dimensionError(linkLength, state.item, 'linkLength');
      const error = dimensionError(width, state.item, 'width') || dimensionError(length, state.item, 'length') || linkError;
      linkInputGroup.hidden = linkMode !== 'custom';
      linkLengthInput.setAttribute('aria-invalid', String(Boolean(linkError)));
      root.querySelectorAll('[data-oval-link-length]').forEach(b => {
        const selected = linkMode === 'preset' && b.dataset.ovalLinkLength === selectedLinkLength;
        b.setAttribute('aria-pressed', String(selected));b.classList.toggle('is-selected', selected);
      });
      root.querySelectorAll('[data-oval-link-mode]').forEach(b => {
        const selected = b.dataset.ovalLinkMode === linkMode;
        b.setAttribute('aria-pressed', String(selected));b.classList.toggle('is-selected', selected);
      });
      validation.textContent = error;validation.hidden = !error;copyButton.disabled = Boolean(error);
      customWidthInput.setAttribute('aria-invalid', String(Boolean(dimensionError(width, state.item, 'width'))));
      customLengthInput.setAttribute('aria-invalid', String(Boolean(dimensionError(length, state.item, 'length'))));
      root.querySelectorAll('[data-oval-item]').forEach(b => {
        const selected = b.dataset.ovalItem === state.item;
        b.setAttribute('aria-pressed', String(selected));
        b.classList.toggle('is-selected', selected);
      });
      root.querySelectorAll('[data-oval-structure]').forEach(b => {
        const selected = b.dataset.ovalStructure === state.structure;
        b.setAttribute('aria-pressed', String(selected));
        b.classList.toggle('is-selected', selected);
      });
      root.querySelectorAll('[data-oval-width]').forEach(b => {
        const selected = !customWidth.trim() && b.dataset.ovalWidth === state.width;
        b.setAttribute('aria-pressed', String(selected));
        b.classList.toggle('is-selected', selected);
      });
      root.querySelectorAll('[data-oval-length]').forEach(b => {
        const matches = b.dataset.ovalFor === state.item;
        const selected = matches && !customLengths[state.item].trim() && b.dataset.ovalLength === state.length;
        b.hidden = !matches;
        b.setAttribute('aria-pressed', String(selected));
        b.classList.toggle('is-selected', selected);
      });
      root.querySelectorAll('[data-oval-clasp]').forEach(b => {
        const selected = b.dataset.ovalClasp === state.clasp;
        b.setAttribute('aria-pressed', String(selected));
        b.classList.toggle('is-selected', selected);
      });
      get('item').textContent = itemLabel[state.item];
      get('width').textContent = width + 'mm（希望）';
      get('length').textContent = length + 'cm（希望）';
      get('link-length').textContent = linkLength === null ? '相談して決める' : linkError ? 'ご希望の長さをご入力ください' : linkLength + 'mm（希望）';
      get('clasp').textContent = claspLabel[state.clasp];
      get('structure').textContent = structureLabel[state.structure];
      get('metal').textContent = metalColor.toUpperCase() + '（' + metalLabel[metalColor] + '）';
      get('material').textContent = 'K18' + metalLabel[metalColor] + 'を希望（要確認）';
      root.querySelectorAll('[data-oval-metal]').forEach(b => {const selected = b.dataset.ovalMetal === metalColor;b.setAttribute('aria-pressed', String(selected));b.classList.toggle('is-selected',selected);});
      get('pricing').textContent = 'お見積もり時にご案内いたします';
      root.querySelector('[data-oval-structure-badge]').textContent = state.structure === 'solid' ? 'SOLID CHAIN' : 'HOLLOW CHAIN';
      const hint = root.querySelector('[data-oval-length-hint]');
      hint.textContent = state.item === 'necklace'
        ? 'ネックレスは40〜70cmの範囲でお選びいただけます。候補にない長さもご入力いただけます。'
        : '表示はご相談用の長さの候補です。その他の長さもご入力いただけます。手首周りと完成品の長さは異なります。';
      const caption = root.querySelector('[data-oval-image-caption]');
      caption.textContent = state.item.toUpperCase() + ' / K18 YELLOW GOLD';
      const source = root.dataset[state.item === 'necklace' ? 'photoNecklace' : 'photoBracelet'];
      if (photo && source) {
        photo.src = source;
        photo.alt = 'Cilea オーバルライン' + itemLabel[state.item] + 'の既存参考写真';
        photo.srcset = '';
      }
      drawCombination(width, linkLength, length, error);
      let draft = null;
      if (!error && window.CileaConsultation) {
        try { draft = window.CileaConsultation.createOvalDraft({item: state.item, structure: state.structure, width, length, linkLength, clasp: state.clasp, metalColor: metalColor}); } catch (_) {}
      }
      quoteText.value = draft ? draft.text : '';
      copyButton.disabled = !draft;
      lineLink.setAttribute('aria-disabled', String(!draft));
      if (draft) { lineLink.href = draft.prefillUrl;lineLink.removeAttribute('tabindex'); }
      else { lineLink.removeAttribute('href');lineLink.setAttribute('tabindex', '-1'); }

      copyStatus.textContent = 'LINEの入力欄にご相談内容が入ります。内容をご確認のうえ、ご自身で送信してください。';
      updateStep();
    }
    linkLengthInput.addEventListener('input',()=>{if(customLinkLength!==linkLengthInput.value)markCustomSelection();customLinkLength=linkLengthInput.value;sync();});
    customWidthInput.addEventListener('input',()=>{if(customWidth!==customWidthInput.value)markCustomSelection();customWidth=customWidthInput.value;sync();});
    customLengthInput.addEventListener('input',()=>{if(customLengths[state.item]!==customLengthInput.value)markCustomSelection();customLengths[state.item]=customLengthInput.value;sync();});
    root.addEventListener('click', async function (event) {
      const button = event.target.closest('button');
      if (!button || !root.contains(button) || button.disabled) return;
      const d = button.dataset;
      const beforeSelection = selectionKey();
      if (d.ovalItem) {
        lengths[state.item] = state.length;
        state.item = d.ovalItem;
        state.length = lengths[state.item];
        customLengthInput.value = customLengths[state.item];
      } else if (d.ovalLinkLength) { selectedLinkLength = d.ovalLinkLength;linkMode = 'preset'; }
      else if (d.ovalLinkMode) linkMode = d.ovalLinkMode;
      else if (d.ovalMetal) metalColor = d.ovalMetal;
      else if (d.ovalStructure) state.structure = d.ovalStructure;
      else if (d.ovalWidth) { state.width = d.ovalWidth;customWidth='';customWidthInput.value=''; }
      else if (d.ovalLength) { state.length = d.ovalLength;customLengths[state.item]='';customLengthInput.value=''; }
      else if (d.ovalClasp) state.clasp = d.ovalClasp;
      else if (button.hasAttribute('data-oval-copy')) {
        try {
          await navigator.clipboard.writeText(quoteText.value);
          copyStatus.textContent = '選択内容をコピーいたしました。送信はされておりません。';
        } catch (error) {
          quoteText.hidden = false;
          quoteText.focus();
          quoteText.select();
          copyStatus.textContent = '内容を選択いたしました。コピーしてご利用ください。送信はされません。';
        }
        return;
      } else return;
      if (selectionKey() !== beforeSelection) markCustomSelection();
      sync();
    });
    sync();
    if (!window.CileaConsultation) {
      document.querySelectorAll('script[src*="cilea-consultation.js"]').forEach(script => script.addEventListener('load', sync, { once: true }));
      document.addEventListener('DOMContentLoaded', sync, { once: true });
      if (typeof window.addEventListener === 'function') window.addEventListener('load', sync, { once: true });
    }

  }
  function start() {
    document.querySelectorAll('[data-cilea-oval]').forEach(install);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
